import React, { useState, useEffect, useRef } from 'react';
import { ErrorMessage } from "formik";
import './index.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { connect } from 'react-redux';

function LocationSearchInput(props) {
  const {
    field: { name },
    form: { touched, errors, setFieldValue, setFieldError, setFieldTouched },
    value,
    usuario,
  } = props;

  const error = errors[name];
  const touch = touched[name];
  const [address, setAddress] = useState(value || "");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (usuario) {
      setAddress(usuario.direccionValor);
      setFieldValue(name, {
        value: usuario.direccionValor,
        address: usuario.direccionValor,
        coordinates: {
          lat: parseFloat(usuario.lat),
          lng: parseFloat(usuario.lng)
        }
      });
    }
  }, []);

  function fetchSuggestions(query) {
    if (!query || query.length < 3) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&addressdetails=1&limit=5&countrycodes=ar`)
      .then(res => res.json())
      .then(data => {
        setSuggestions(data || []);
        setLoading(false);
      })
      .catch(err => {
        setSuggestions([]);
        setLoading(false);
        setFieldError(name, 'Error buscando direcciones');
      });
  }

  function handleChange(e) {
    const val = e.target.value;
    setAddress(val);
    setFieldTouched(`${name}.value`);
    setFieldTouched(`${name}.address`);
    setFieldValue(name, { value: val });

    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => fetchSuggestions(val), 300);
  }

  function handleSelect(suggestion) {
    const selectedAddress = suggestion.display_name;
    const lat = parseFloat(suggestion.lat);
    const lng = parseFloat(suggestion.lon);

    setAddress(selectedAddress);
    setSuggestions([]);
    setFieldValue(name, {
      value: selectedAddress,
      address: selectedAddress,
      coordinates: { lat, lng }
    });
  }

  function onBlur() {
    // Delay para permitir click en sugerencia antes de cerrar
    setTimeout(() => setSuggestions([]), 200);
    if (address === '') {
      setFieldTouched(`${name}.value`);
      setFieldTouched(`${name}.address`);
      setFieldValue(name, { value: '' });
    }
  }

  return (
    <div>
      <input
        type="text"
        name={name}
        id={name}
        value={address}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder="Buscar direccion ..."
        className={"location-search-input form-control form-controlCustom" + (error && touch ? ' is-invalid' : '')}
      />

      <div className="autocomplete-dropdown-container">
        {loading && <div>Loading...</div>}
        {suggestions.map((suggestion, index) => (
          <div
            className="locationSearchInput-inputSuggestion"
            key={index}
            onMouseDown={() => handleSelect(suggestion)}
            style={{ backgroundColor: '#ffffff', cursor: 'pointer' }}
          >
            <LocationOnIcon /> <span>{suggestion.display_name}</span>
          </div>
        ))}
      </div>

      {error && error.value && <ErrorMessage name='location.value' component="div" className="invalid-feedback" />}
      {error && !error.value && error.address && <ErrorMessage name='location.address' component="div" className="invalid-feedback" />}
    </div>
  );
}

export default connect(null, null)(LocationSearchInput);
